import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import styles from './ActionButtons.module.css';
import { analytics } from '@/utils/analytics';

interface ActionButton {
  id: string;
  label: string;
}

interface ActionButtonsProps {
  buttons: ActionButton[];
  onButtonClick: (apiText: string, displayText: string) => void;
}

/**
 * Интерактивные кнопки действий под сообщением ассистента.
 * Клик отправляет button.id в API, но показывает button.label в чате.
 * После клика все кнопки блокируются, нажатая выделяется.
 */
export function ActionButtons({ buttons, onButtonClick }: ActionButtonsProps) {
  const [clickedId, setClickedId] = useState<string | null>(null);

  const handleClick = (btn: ActionButton) => {
    if (clickedId) return;
    setClickedId(btn.id);
    analytics.actionButtonClicked(btn.id);
    onButtonClick(btn.id, btn.label);
  };

  return (
    <div className={styles.container}>
      {buttons.map((btn) => (
        <button
          key={btn.id}
          type="button"
          className={`${styles.button} ${clickedId === btn.id ? styles.active : ''} ${clickedId && clickedId !== btn.id ? styles.disabled : ''}`}
          onClick={() => handleClick(btn)}
          disabled={!!clickedId}
        >
          <span className={styles.text}>{btn.label}</span>
          <span className={styles.arrow}>
            <ChevronRight size={14} strokeWidth={2} />
          </span>
        </button>
      ))}
    </div>
  );
}
